<template>
  <div v-if="errors.length" class="d-flex flex-column">
    <v-btn color="error" class="toggle-btn" @click="toggleErrors">
      {{ isCollapsed ? 'Fehler anzeigen' : 'Fehler ausblenden' }}
    </v-btn>

    <v-list v-show="!isCollapsed" class="overflow-list ">
      <v-list-item class="d-flex justify-center align-center w-100" v-for="(error, index) in groupedErrors" :key="index">
        <v-card class="error-card" outlined>
          <div class="error-message ">
            {{ error.ruleMessage }}
          </div>
        </v-card>
      </v-list-item>
    </v-list>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import {RuleBreakData} from "@/rules/ruleEngine";

export default defineComponent({
  name: 'ErrorList',
  props: {
    errors: {
      type: Array as PropType<RuleBreakData[]>, // Type as an array of strings
      required: true
    }
  },
  data() {
    return {
      isCollapsed: true
    };
  },
  computed: {
    groupedErrors() {
      return this.errors.reduce((acc: RuleBreakData[], error: RuleBreakData) => {
        const existingGroup = acc.find((group) => group.ruleShortMessage === error.ruleShortMessage);

        if (!existingGroup) {
          acc.push(error);
        } 
        
        return acc;
      }, []);
    }
  },
  methods: {
    toggleErrors() {
      this.isCollapsed = !this.isCollapsed;
    }
  }
});
</script>

<style scoped>

:deep(.v-list-item__content)
{
  width:100%;
}

.overflow-list {
  width: 100%;
/*  position: absolute; 
  bottom: 40px; */
  right: 0px;
  z-index: 1000; 
  background-color: rgba(255, 255, 255, 0.9);
  padding: 4px;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
  max-height: 500px; 
  overflow-y: auto;
  margin-top: 10px; 
}

.error-card {
  margin-bottom: 1px; 
  padding: 2px; 
  border: 1px solid #ccc; 
  background-color: #f9f9f9; 
}

.full-width-item {
  width: 100%;
}

.error-message {
  color: #721c24; 
  font-weight: bold;
}
</style>